import React, { useState } from 'react'
import styled from '@emotion/styled'

import Profile from '../Profile'
import SideBarList from '../SideBarList'
import SideBarItem from '../SideBarItem'
import vendorAtom from '@src/atom/vendor'
import { useRecoilValue } from 'recoil'

type SideTabListType = {
	id: string
	title: string
	isOpen: boolean
	item: SideTabItemType[]
}

type SideTabItemType = {
	text: string
	iconName: string
	to: string
}

const SideBar = () => {
	const vendor = useRecoilValue(vendorAtom)

	const { profileImg, username, role } = vendor

	const [sideTabList, setSideTabList] = useState<SideTabListType[]>([
		{
			id: 'tab-index-1',
			title: '상품 관리',
			isOpen: true,
			item: [
				{
					text: '상품등록',
					to: '/product/registration',
					iconName: 'clipboard',
				},
			],
		},
		{
			id: 'tab-index-2',
			title: '주문 관리',
			isOpen: true,
			item: [
				{
					text: '주문 조회',
					to: '/order',
					iconName: 'documentMagnifyingGlass',
				},
			],
		},
	])

	return (
		<SideBarWrapper>
			<Profile profileImg={profileImg} username={username} />
			<NavMenu>
				<SideBarList title="챌린지 관리">
					<SideBarItem icon="create" text="핫딜 챌린지 생성" to="/challenge/hotdeal-registration" />
					<SideBarItem icon="search" text="등록 챌린지 조회" to="/challenge" />
				</SideBarList>
				{role === 'SUPER_ADMIN' ? (
					<>
						<SideBarList title="상품 관리">
							<SideBarItem icon="clipboard" text="상품등록" to="/product/registration" />
							<SideBarItem icon="box" text="등록상품 조회" to="/product" />
						</SideBarList>
						<SideBarList title="주문 관리">
							<SideBarItem icon="documentMagnifyingGlass" text="주문 조회" to="/order" />
							{/* <SideBarItem icon="documentUser" text="고객 주문 관리" to="/" />
							<SideBarItem icon="documentDelete" text="주문 취소 / 교환 • 환불" to="/" /> */}
						</SideBarList>
						<SideBarList title="환급 관리">
							<SideBarItem icon="refund" text="환급 내역 조회" to="/refund" />
						</SideBarList>
					</>
				) : null}
				<SideBarList title="결제 관리">
					<SideBarItem
						icon="card"
						text="카드등록"
						to="/payment/subscribe/plan"
						matches={['/payment/subscribe/plan', '/payment/subscribe/info']}
					/>
				</SideBarList>
				<SideBarList title="브랜드 정보 관리">
					<SideBarItem icon="profile" text="브랜드 정보" to="/vendor/profile" />
				</SideBarList>
			</NavMenu>
		</SideBarWrapper>
	)
}

const SideBarWrapper = styled.aside`
	flex: 0 1 auto;
	display: flex;
	flex-direction: column;
	width: 27.7rem;
	height: 100%;
	background-color: #f8f9fc;
	padding-top: 3rem;
	padding-bottom: 8rem;
	overflow-y: scroll;
`

const NavMenu = styled.div`
	flex: 1;
	width: 100%;
`

export default SideBar
